import { Box, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";
import { OutlierHeatsPanel } from "./OutlierHeatsPanel";
import { OutlierHeatsProvider } from "./OutlierHeatsContext";

interface OutlierHeatsRegionProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export const OutlierHeatsRegion = ({
  children,
  sx,
}: OutlierHeatsRegionProps) => {
  const mergedSx: SxProps<Theme> = [
    { position: "relative", height: "100%" },
  ].concat(sx ? (Array.isArray(sx) ? sx : [sx]) : []);

  return (
    <OutlierHeatsProvider>
      <Box sx={mergedSx}>
        {children}
        <OutlierHeatsPanel />
      </Box>
    </OutlierHeatsProvider>
  );
};
